import React from "react";
import "./BridalMakeup.css";

function BridalMakeup(props) {
  const { children, className } = props;

  return (
    <div className={`bridal-makeup-1 border-1px-sonic-silver ${className || ""}`}>
      <div className="x-makeup poppins-medium-tundora-10px">{children}</div>
    </div>
  );
}

export default BridalMakeup;
